import React, { useMemo } from 'react';

const PartnerOnBehalfSelection = ({
  companies,
  loading,
  error,
  selection,
  fieldErrors = {},
  onChange,
}) => {
  const selectedCompany = useMemo(
    () => companies.find((company) => company.id === selection.partnerCompanyId) || null,
    [companies, selection.partnerCompanyId],
  );

  const contactOptions = selectedCompany?.users || [];

  const handleCompanyChange = (event) => {
    const partnerCompanyId = event.target.value;
    const company = companies.find((item) => item.id === partnerCompanyId);

    onChange({
      partnerCompanyId,
      companyName: company?.companyName || '',
      csn: company?.csn || '',
      partnerName: '',
      partnerEmail: '',
      partnerContactKey: '',
    });
  };

  const handleContactChange = (event) => {
    const partnerContactKey = event.target.value;
    if (!partnerContactKey) {
      onChange({
        partnerContactKey: '',
        partnerName: selection.partnerName,
        partnerEmail: selection.partnerEmail,
      });
      return;
    }

    const contact = contactOptions.find((user) => (
      (user.id || user.email) === partnerContactKey
    ));

    onChange({
      partnerContactKey,
      partnerName: contact?.partnerName && contact.partnerName !== '-' ? contact.partnerName : '',
      partnerEmail: contact?.email && contact.email !== '-' ? contact.email : '',
    });
  };

  return (
    <div className="partner-form-card partner-on-behalf-card partner-form">
      <div className="partner-form-card-head">
        <h5 className="partner-form-card-title">
          <span className="partner-card-check" />
          Partner selection
        </h5>
        <p className="partner-on-behalf-card-subtitle">Submit on behalf of a partner organization.</p>
      </div>

      {error ? <p className="partner-on-behalf-error text-danger">{error}</p> : null}

      <div className="row g-3">
        <div className="col-md-6">
          <label htmlFor="partner-on-behalf-company">Partner Company *</label>
          <select
            id="partner-on-behalf-company"
            className={`partner-form-select form-select ${fieldErrors.partnerCompanyId ? 'is-invalid' : ''}`}
            value={selection.partnerCompanyId}
            onChange={handleCompanyChange}
            disabled={loading}
          >
            <option value="">Select partner company</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.companyName || company.csn || 'Partner company'}
              </option>
            ))}
          </select>
          {fieldErrors.partnerCompanyId ? (
            <small className="text-danger">{fieldErrors.partnerCompanyId}</small>
          ) : null}
        </div>

        <div className="col-md-6">
          <label htmlFor="partner-on-behalf-csn">Partner CSN *</label>
          <input
            id="partner-on-behalf-csn"
            className={`form-control ${fieldErrors.csn ? 'is-invalid' : ''}`}
            value={selection.csn}
            readOnly
          />
          {fieldErrors.csn ? <small className="text-danger">{fieldErrors.csn}</small> : null}
          {!fieldErrors.csn ? (
            <small className="partner-helper-text">Auto populated from the selected partner company</small>
          ) : null}
        </div>

        <div className="col-md-6">
          <label htmlFor="partner-on-behalf-contact">Partner Contact</label>
          <select
            id="partner-on-behalf-contact"
            className="partner-form-select form-select"
            value={selection.partnerContactKey}
            onChange={handleContactChange}
            disabled={!selection.partnerCompanyId || contactOptions.length === 0}
          >
            <option value="">Select partner contact (optional)</option>
            {contactOptions.map((user) => {
              const contactKey = user.id || user.email;
              const label = user.partnerName && user.partnerName !== '-'
                ? `${user.partnerName}${user.email && user.email !== '-' ? ` · ${user.email}` : ''}`
                : (user.email || 'Partner contact');
              return (
                <option key={contactKey} value={contactKey}>
                  {label}
                </option>
              );
            })}
          </select>
          <small className="partner-helper-text">Optional — select a known partner contact to prefill details</small>
        </div>

        <div className="col-md-6">
          <label htmlFor="partner-on-behalf-name">Partner name *</label>
          <input
            id="partner-on-behalf-name"
            className={`form-control ${fieldErrors.partnerName ? 'is-invalid' : ''}`}
            placeholder="Enter partner name"
            value={selection.partnerName}
            onChange={(event) => onChange({ partnerName: event.target.value })}
          />
          {fieldErrors.partnerName ? <small className="text-danger">{fieldErrors.partnerName}</small> : null}
        </div>

        <div className="col-md-6">
          <label htmlFor="partner-on-behalf-email">Partner Email *</label>
          <input
            id="partner-on-behalf-email"
            className={`form-control ${fieldErrors.partnerEmail ? 'is-invalid' : ''}`}
            placeholder="email@partnercompany.com"
            value={selection.partnerEmail}
            onChange={(event) => onChange({ partnerEmail: event.target.value })}
          />
          {fieldErrors.partnerEmail ? <small className="text-danger">{fieldErrors.partnerEmail}</small> : null}
        </div>
      </div>
    </div>
  );
};

export default PartnerOnBehalfSelection;
